export default "__VITE_ASSET__b1e0HhUe__"